module.exports = __webpack_public_path__ + "img/speaker_27.e50b46b3.jpg";